import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { PrimaryButton } from '@moonpig/launchpad-components'
import { IconSystemChevronUp } from '@moonpig/launchpad-assets'
import {
  createGenericSelectContentEvent,
  trackGAEvent,
} from '@moonpig/web-core-analytics'
import { useSearchAnalytics } from '../../pages/SearchPage/analytics'
import { scrollToTopEvent } from '../../pages/SearchPage/events'
import { useFindLocaleText } from '../../text-localisation'

type ScrollToTopProps = {
  showScrollToTop: boolean
}

const TRANSITION_TIME = 150

const StyledPrimaryButton = styled(PrimaryButton)<ScrollToTopProps>`
  ${s({
    mr: { xs: 6, md: 5 },
    mb: 5,
    border: 0,
    p: { xs: 5, md: 6 },
  })}
  display: flex;
  margin-left: auto;
  opacity: ${({ showScrollToTop }) => (showScrollToTop ? `1` : `0`)};
  transition: opacity ${TRANSITION_TIME}ms ease-in-out;
  pointer-events: auto;
`

export const ScrollToTop: FC<ScrollToTopProps> = ({ showScrollToTop }) => {
  const isLaunchpadAnalytics = useSearchAnalytics()

  const [display, setDisplay] = React.useState(false)
  const localiseText = useFindLocaleText()

  React.useEffect(() => {
    if (showScrollToTop) {
      setDisplay(true)
    } else {
      setTimeout(() => {
        setDisplay(false)
      }, TRANSITION_TIME)
    }
  }, [showScrollToTop, setDisplay])
  return (
    <StyledPrimaryButton
      showScrollToTop={showScrollToTop}
      type="button"
      aria-hidden={!display}
      aria-label={localiseText('find.scroll_to_the_top_of_the_viewport')}
      tabIndex={display ? 0 : -1}
      events={
        isLaunchpadAnalytics ? { onClick: scrollToTopEvent() } : undefined
      }
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        // Launchpad event: apps/explore/find/src/pages/SearchPage/events.ts
        if (!isLaunchpadAnalytics)
          trackGAEvent(
            createGenericSelectContentEvent({
              eventAction: 'utility links',
              eventCategory: 'navigation',
              eventLabel: 'jump to top',
            }),
          )
      }}
    >
      <IconSystemChevronUp width="24" height="24" />
    </StyledPrimaryButton>
  )
}
